<template>
  <div class="pb-12">
    <v-row no-gutters>
      <v-col
        id="payment"
        :class="$vuetify.breakpoint.mdAndUp ? '' : 'px-6'"
        :order="$vuetify.breakpoint.mdAndUp ? '0' : '1'"
        :cols="$vuetify.breakpoint.mdAndUp && !$route.query.embed ? '8' : '12'"
      >
        <Payment
          :productsTotal="productsTotal"
          :showPixScreen="showPixScreen"
          :loading="loading"
          @purchase="purchase"
          @return="showPixScreen = false"
        />
      </v-col>
      <v-col
        v-if="!$route.query.embed"
        :style="$vuetify.breakpoint.mdAndUp ? '' : 'background-color: #eee;'"
        :order="$vuetify.breakpoint.mdAndUp ? '1' : '0'"
        :cols="$vuetify.breakpoint.mdAndUp ? '4' : '12'"
      >
        <Summary
          style="position: sticky; top: 65px"
          :showPixScreen="showPixScreen"
          @purchase="purchase"
          :loading="loading"
        />
      </v-col>
    </v-row>

    <secure-modal
      :showModal3DS="showModal3DS"
      :data3ds="data3ds"
      :transactionId="transactionId"
      @closeModal="closeSecureModal"
    />
  </div>
</template>

<script>
import Summary from "../components/summary/Index.vue";
import Payment from "../components/payment/Index.vue";
import { mapGetters } from "vuex";
import SecureModal from "../components/payment/3DSecure.vue";
import axios from "axios";
export default {
  components: { Summary, Payment, SecureModal },
  data() {
    return {
      loading: false,
      showPixScreen: false,
      nominationFinished: false,
      showModal3DS: false,
      data3ds: null,
      now: Math.trunc(new Date() / 1000),
      transactionId: null,
    };
  },
  async mounted() {
    let storage = await JSON.parse(
      localStorage.getItem(`cart-order-route-${this.eventId}`)
    );
    if (!this.orderDetails && !this.$route.query.order_hash && !storage)
      this.$router.push({
        name: "Cart",
        params: { event: this.eventId },
        query: this.$route.query,
      });
    if (
      this.productsTotal ||
      (this.orderDetails && this.orderDetails.valor_pendente)
    )
      this.fetchPaymentOptions();
    this.$store.dispatch("setPaymentOption", null);
    this.handleScrollTo(
      "#payment",
      this.$vuetify.breakpoint.mdAndUp ? -100 : -55
    );

    const waitAuthentication = await localStorage.getItem(
      `wait-authentication-${this.eventId}`
    );
    if (waitAuthentication) {
      this.$store.commit("SHOW_SECURITY_CHECK", true);
      this.$store.commit(
        "SET_FINAL_DETAILS",
        JSON.parse(waitAuthentication).finalDetails
      );
      this.$store.commit(
        "SET_BUYER_DATA",
        JSON.parse(waitAuthentication).buyer
      );
      this.$store.dispatch("setPaymentOption", "CC");
    }
  },
  computed: {
    ...mapGetters([
      "productsDetails",
      "couponDetails",
      "paymentDetails",
      "eventDetails",
      "orderDetails",
      "productsTotal",
      "noSectorList",
      "paymentOption",
      "loginPosData",
      "nominationValid",
      "buyer",
      "countries",
      "cartProducts",
      "eventId",
    ]),
  },
  watch: {
    productsTotal(v) {
      if (v && !this.$route.query.order_hash) this.fetchPaymentOptions();
    },
    showPixScreen(v) {
      if (!v) this.loading = false;
    },
  },
  methods: {
    fetchPaymentOptions() {
      let coupon = null;

      if (this.couponDetails) {
        coupon = this.couponDetails.cupomData.campaign_coupon;
      }

      this.$store.dispatch("fetchPaymentOptions", {
        event: this.eventId,
        value: this.$route.query.order_hash
          ? this.orderDetails.valor_pendente
          : this.productsTotal,
        pdv: this.orderDetails ? this.orderDetails.pdv : "",
        coupon: coupon,
      });
    },

    open3DSMercadoPago(data) {
      this.transactionId = data.tid;
      this.data3ds = data.challenge;
      this.showModal3DS = true;
    },

    closeSecureModal() {
      this.showModal3DS = false;
      this.$store.commit("SET_SECURE_3DS_OPEN", false);
    },

    async purchaseBillet(params) {
      this.loading = true;
      await this.$store
        .dispatch("paymentBillet", params)
        .then((resp) => {
          if (resp && resp.status === 200) {
            this.$router.push({
              name: "Finished",
              params: { event: this.eventId },
              query: this.$route.query,
            });
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 410) this.goCart();
        });
      this.loading = false;
    },

    async purchaseCard(params) {
      let mercadoPago = null;

      if (this.paymentDetails.credit_card_gateway === "MERCADO-PAGO") {
        mercadoPago = await this.encryptCardMercadoPago(params);
      }

      if (mercadoPago) params.mercadoPago = mercadoPago;

      this.loading = true;
      await this.$store
        .dispatch("paymentCard", params)
        .then((resp) => {
          if (resp?.status === 200) {
            if (
              resp.data.status == "paid" ||
              resp.data.status == "in_process"
            ) {
              let orderData = resp?.data?.orderData;
              if (
                orderData?.status === "S" &&
                orderData?.valida_token_pagamento
              ) {
                this.$store.commit("SHOW_SECURITY_CHECK", true);
                this.loading = false;
                return;
              }

              this.$router.push({
                name: "Finished",
                params: { event: this.eventId },
                query: this.$route.query,
              });
            } else if (resp?.data?.status == "refused") {
              this.$store.commit(
                "SET_ERROR_MESSAGE_CARD",
                resp?.data?.message ? resp.data.message : "Erro no pagamento"
              );
            } else if (resp?.data?.status == "3ds") {
              const { data } = resp;

              if (data?.challenge?.status === "pending_challenge")
                this.open3DSMercadoPago(data);
              else this.checkPurchaseStatus();
            }
          }
        })
        .catch((error) => {
          if (error?.response?.status === 410) this.goCart();
        });
      this.loading = false;
    },

    async purchasePix(params) {
      this.showPixScreen = true;
      await this.$store.dispatch("paymentPix", params);
    },

    async purchaseCoutersy(params) {
      await this.$store
        .dispatch("confirmOrder", params)
        .then((resp) => {
          if (resp && resp.success) {
            this.$router.push({
              name: "Finished",
              params: { event: this.eventId },
              query: this.$route.query,
            });
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 410) this.goCart();
        });
      this.loading = false;
    },

    async purchaseInvoice(params) {
      await this.$store
        .dispatch("paymentInvoice", params)
        .then((resp) => {
          console.log(resp);
          if (resp && resp.status === 200) {
            this.$router.push({
              name: "Finished",
              params: { event: this.eventId },
              query: this.$route.query,
            });
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 410) this.goCart();
        });
      this.loading = false;
    },

    async purchase() {
      this.productsTotal;

      let phone = "";

      if (this.productsTotal !== 0) {
        phone =
          this.buyer.countryPhone == "BR"
            ? this.buyer.customer_phone
            : `+${
                this.countries.find(
                  (country) => country.iso == this.buyer.countryPhone
                ).code
              } ${this.buyer.customer_phone}`;
      }

      let params = {
        buyer: {
          ...this.buyer,
          customer_phone: phone,
        },
        event: this.eventId,
        order: this.orderDetails.codigo,
      };
      this.loading = true;

      if (
        (this.eventDetails.one_checkout === 40 ||
          this.eventDetails.one_checkout === 42) &&
        this.nominationValid &&
        !this.nominationFinished
      ) {
        let nominationError = false;
        await this.$store
          .dispatch("saveNamedTicket", this.orderDetails.ingressos)
          .then(() => {
            this.nominationFinished = true;
          })
          .catch((e) => {
            this.loading = false;
            nominationError = true;
            this.$store.dispatch("openSnackbar", {
              message: e?.response?.data?.message || "Erro na nomeação",
              color: "error",
            });
          });
        if (nominationError) return;
      }

      if (this.paymentOption === "BB") this.purchaseBillet(params);
      else if (this.paymentOption === "CC") this.purchaseCard(params);
      else if (this.paymentOption === "PIX") this.purchasePix(params);
      else if (this.paymentOption === "INVOICE") this.purchaseInvoice(params);
      else if (this.productsTotal === 0) {
        if (this.orderDetails?.ingressos?.length === 1) {
          let ticket = this.orderDetails?.ingressos[0];

          const getExtraDataValue = (type) => {
            return (
              ticket?.dados_extras?.find((tde) => tde.tipo === type)?.valor ||
              ""
            );
          };

          let customer = {};

          customer.customer_name = getExtraDataValue("nome");
          customer.customer_email = getExtraDataValue("email");
          customer.customer_phone = getExtraDataValue("telefone");
          customer.customer_doc = getExtraDataValue("documentos");

          params.customer = customer;
        }

        this.purchaseCoutersy(params);
      }
    },

    handleScrollTo(element, ofs) {
      this.$scrollTo(element, 500, {
        offset: ofs,
      });
    },

    async encryptCardMercadoPago(data) {
      const { buyer } = data;
      const mp = new window.MercadoPago(
        this.paymentDetails.credit_card_tokenizer
      );

      const { results } = await mp.getPaymentMethods({
        bin: String(buyer.card_number.replaceAll(" ", "").slice(0, 8)),
      });

      const paymentMethod = results[0];

      const typeDocument =
        buyer.typeDocument === "CPF" || buyer.typeDocument === "CNPJ"
          ? buyer.typeDocument
          : "";
      let numberDocument = "";

      if (buyer.typeDocument === "CPF" || buyer.typeDocument === "CNPJ")
        numberDocument = buyer.customer_doc.replace(/\D/g, "");

      const token = await mp.createCardToken({
        cardholderName: buyer.card_name,
        cardNumber: buyer.card_number.replaceAll(" ", ""),
        securityCode: buyer.card_cvv,
        cardExpirationMonth: buyer.card_expiration.slice(0, 2),
        cardExpirationYear: `20${buyer.card_expiration.slice(3)}`,
        identificationType: typeDocument,
        identificationNumber: numberDocument,
      });

      var md5 = require("md5");

      let replacedCardNumber = buyer.card_number.replaceAll(" ", "");

      let params = {
        card_encrypted: token.id,
        card_hash: `${replacedCardNumber.slice(
          0,
          6
        )}******${replacedCardNumber.slice(12)}`,
        card_hash_full: md5(replacedCardNumber).replaceAll(" ", "$0u1BT"),
        card_brand: paymentMethod.id,
      };

      return params;
    },

    async goCart() {
      this.$router.push({
        name: "Cart",
        params: { event: this.eventId },
        query: this.$route.query,
      });
      await this.$store.dispatch("getProductsAndSectors", {
        event: this.eventId,
        coupon: this.$route.query.c,
      });
    },

    async checkPurchaseStatus() {
      let headers = { checkout: "one-checkout" };

      const { data } = await axios.get(
        `pdv/orders/charge/status?order_hash=${this.orderDetails?.hash_pedido}`,
        null,
        { headers }
      );

      if (data && data.status === "paid") {
        this.$store.commit("SET_FINAL_DETAILS", data);
        this.$router.push({
          name: "Finished",
          params: { event: this.eventId },
          query: this.$route.query,
        });
      } else {
        this.$store.commit(
          "SET_ERROR_MESSAGE_CARD",
          data.message ? data.message : "Erro no pagamento"
        );
      }
    },

    findTokenPerType(type) {
      return this.eventDetails?.integracoes_publicas?.find(
        (i) => i.tipo === type
      )?.credenciais?.token;
    },
  },
};
</script>
